import styled from 'styled-components';
import {Space} from 'antd';

const StyledUserOverviewRightPanel = styled(Space)`
  width: 100%;
  & > .ant-space-item {
    display: flex;

    .ant-card {
      width: 100%;
    }
  }

  .ant-card-head {
    min-height: 40px;
  }
`;


export {
  StyledUserOverviewRightPanel
}
